
import moment from 'moment';
import { Component, Vue, Emit, Mixins } from 'vue-property-decorator';
import { GameArea } from '@/mixins/game_area';
import { PageQuery } from '@/mixins/page_query';
import { getConfigLength, getAreaLength } from '@/api/statistics';
import LogUtils from 'panda-log';

@Component
export default class DataTable extends Mixins(GameArea, PageQuery) {
  @Emit() goto(obj: object) {
    LogUtils.info(obj);
  }
  private init = 0;
  private start!: any;
  private end!: any;
  public dates: (string | Date)[] = [
    moment()
      .subtract('days', 7)
      .format('YYYY-MM-DD'),
    moment('23:59:59', 'HH:mm:ss').format(),
  ];
  private totalBoot = 0;
  private totalConnect = 0;

  private lengthTable = [
    // {
    //   config_id: 1,
    //   boot_duration: 2200,
    //   connect_duration: 2234,
    // },
  ];

  // 网吧表格
  private netbarTable = [
    // {
    //   id: 12,
    //   start: 1586310990,
    //   end: 1586319000,
    //   region_name: '华北区',
    //   area_name: '极限网吧',
    //   boot_duration: {
    //     standard: 120,
    //     advanced: 100,
    //     total: 220,
    //   },
    //   connect_duration: {
    //     standard: 100,
    //     advanced: 90,
    //     total: 190,
    //   },
    // },
  ];
  //快捷日期:    昨日     本周      上周      本月     上月
  private shortcutDays = ['昨日', '本周', '上周', '本月', '上月'];
  private initDay = -1;

  // 切换大区
  switchArea(i: number) {
    this.init = i;
    this.getServerData();
  }

  unixDate(from: Date, to: Date) {
    this.start = moment(from).unix();
    this.end = moment(to).unix();
  }

  getCurWeek() {
    let now = new Date().getDay();
    return now - 1 < 0 ? 6 : now - 1;
  }

  setDayRange(timeFrom: any, timeTo: any) {
    this.dates = [timeFrom, timeTo];
    this.unixDate(timeFrom, timeTo);
    this.getServerData();
  }

  pickDate(e: MouseEvent) {
    const text = (e.target as any).innerText;
    const _that = this;
    this.initDay = this.shortcutDays.indexOf(text);
    switch (text) {
      case '今日':
        _that.setDayRange(moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss'));
        break;
      case '昨日':
        _that.setDayRange(moment('00:00:00', 'HH:mm:ss').subtract(1, 'days'), moment('23:59:59', 'HH:mm:ss').subtract(1, 'days'));
        break;
      case '本周':
        _that.setDayRange(moment('00:00:00', 'HH:mm:ss').subtract(_that.getCurWeek(), 'days'), moment('23:59:59', 'HH:mm:ss'));
        break;
      case '上周':
        _that.setDayRange(
          moment(
            moment()
              .week(moment().week() - 1)
              .startOf('week')
          ),
          moment(
            moment()
              .week(moment().week() - 1)
              .endOf('week')
          )
        );
        _that.getServerData();
        break;
      case '本月':
        _that.setDayRange(moment().startOf('month'), moment('23:59:59', 'HH:mm:ss'));
        break;
      case '上月':
        _that.setDayRange(
          moment()
            .month(moment().month() - 1)
            .startOf('month'),
          moment()
            .month(moment().month() - 1)
            .endOf('month')
        );
        break;
    }
  }
  // 选择日期
  private dateHandler(e: any) {
    this.initDay = -1;
    this.start = moment(e[0]).unix();
    this.end = moment(e[1]).unix() + (24 * 60 * 60 - 1);
    this.getServerData();
  }

  getServerData() {
    this.getCloudDuration();
    this.getAreaDuration();
  }

  // 获取配置统计时长
  async getCloudDuration() {
    try {
      const durationParams = {
        start: this.start,
        end: this.end,
        regionid: this.init,
      };
      const res = await getConfigLength(durationParams);
      if (res && res.code === 0) {
        this.lengthTable = res.data;
        const _length = this.lengthTable.length;
        if (_length === 2) {
          this.totalBoot = res.data[0].boot_duration + res.data[1].boot_duration;
          this.totalConnect = res.data[0].connect_duration + res.data[1].connect_duration;
        } else if (_length === 1) {
          this.totalBoot = res.data[0].boot_duration;
          this.totalConnect = res.data[0].connect_duration;
        } else {
          this.totalBoot = this.totalConnect = 0;
        }
      }
    } catch (error) {
      LogUtils.debug(error);
    }
  }

  // 获取小区统计时长
  async getAreaDuration() {
    try {
      const durationParams = {
        start: this.start,
        end: this.end,
        regionid: this.init,
      };
      const res = await getAreaLength({ ...durationParams, ...this.page_query });
      if (res) {
        this.netbarTable = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      LogUtils.debug(error);
    }
  }

  mounted() {
    this.pageFn = this.getAreaDuration;
    this.setDayRange(this.dates[0], this.dates[1]);
  }
}
